import styled from 'styled-components';

interface ChatSectionProps {
    showMessage:boolean;
}

export const ChatSec = styled.div<ChatSectionProps>`
    width: 100%;
    max-width: 768px;
    margin: 0 auto;
    padding: 120px 0 30px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: ${(props)=> props.showMessage ? 'space-between' : 'space-between' };
    align-items: center;
    transition: justify-content 0.3s ease;
    overflow: hidden;

    @media (max-width: 768px) {
        padding: 10px 10px;
    }
`

export const ChatRecords = styled.div`
    display:flex;
    flex-direction: column;
    width: 100%;
    overflow-y: scroll;
    flex-grow: 1;
    padding: 0 12px 40px;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px) {
        padding-top: 70px;
    }
`

export const BotMessage = styled.div`
    flex-grow: 0;
    flex-shrink: 0;
    align-self: flex-start;
    max-width: 85%;
    margin-bottom: 1rem;
    z-index: 1;

    p {
        margin: 8px 0;
    }
    .ant-spin-dot-item{
        background-color: #5237ca !important;
    }

    @media (max-width: 768px) {
        max-width: 95%;
    }

`

export const MessageContent = styled.div`
    background: #fff;
    border-radius: 14px;
    padding: 0.75rem 1rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    p {
        color: #666666;
        font-size: 15px;
        line-height: 1.65rem;
    }

    img {
        max-width: 100%;
    }
    
`

export const UserMessage = styled.div`
    background: #fff;
    border-radius: 14px;
    padding: 0.75rem 1rem;
    flex-grow: 0;
    flex-shrink: 0;
    align-self: flex-end;
    max-width: 85%;
    z-index: 1;
    white-space: pre-line;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;

    p {
        margin: 10px 0;
        color: #666666;
        font-size: 15px;
    }

    @media (max-width: 768px) {
        max-width: 95%;
    }

`
interface RecordInputProps {
    // center:boolean;
}
export const RecordInput = styled.div<RecordInputProps>`
    width: 100%;
    position: sticky;
    bottom: 0px;
    z-index: 2;

    @media (max-width: 768px) {
        z-index: 1;
    }
`

export const MessageInput = styled.div`
    display: flex;
    position: relative;
    
    input {
        padding: 12px 18px;
        border-radius: 24px;
        border: none;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
`

interface InputProps {
    bgColor:any;
    disable:boolean;
}
export const VoiceInput = styled.div<InputProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props)=>props.bgColor? props.bgColor :"#FEFDFF"};
    padding: 12px 18px;
    border-radius: 24px;
    cursor: ${(props)=>props.disable ? "unset" :"pointer"};
    position: relative;
    transition: background-color 0.5s ease;
`

interface IconButtonsProps {
    left?:string;
    right?: string;
}

export const MessageButtons = styled.div<IconButtonsProps>`
    display:flex;
    position: absolute;
    right: ${(props)=> props.right ? props.right : 'auto'};
    left: ${(props)=> props.left ? props.left : 'auto'};
    top: 12px;
`

export const InputIcon = styled.img`
    width: 24px;
    height: 24px;
    cursor: pointer;
`

interface SteamPorps {
    // center:boolean;
}
export const StreamSection = styled.div<SteamPorps>`
    position: fixed;
    left: 20px;
    top:200px;
    z-index: 0;
    transition: right 0.5s, bottom 0.5s, top 0.5s;

    @media (max-width: 1600px) {
        top: 200px;
    }

    @media (max-width: 768px) {
        display: none;
    }
`

export const ChartSection = styled.div`
    width: 100%;
    margin-right: 15px;
    h5 {
        margin: 10px 0;
        font-size: 15px;
        font-weight: 500;
    }

    h6 {
        margin: 0;
    }
`

export const ChartMessage = styled.p`

`

export const DefaultChats = styled.div`
    padding: 20px 0 30px;
    max-width: 580px;
    margin: 0 auto;
    h3, p {
        text-align: center;
    }
    p {
        font-size: 14px;
        margin-bottom: 1.5rem;
    }

    h3 {
        margin-top: 0
    }

`

export const DefaultChat = styled.div`
    padding: 18px 20px;
    background: #fff;
    border-radius: 40px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 0.75rem;
    font-weight: 400;
    cursor: pointer;
`

export const MyButton = styled.button`
    background-color: rgb(98, 136, 233);
    border-style: none;
    border-width: 0px;
    border-color: transparent;
    padding: 16px 40px;
    font-size: 15px;
    border-radius: 10px;
    font-weight: bold;
    color: rgb(255, 255, 255);
    cursor: pointer;
    transition: all 0.3s ease 0s;
    box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;
    margin: 0 auto;
    display: block;

    &:hover {
        box-shadow: rgba(150, 51, 255, 0.2) 0px 8px 16px;
    }
`

interface WaveProps {
    show: string;
}
export const WavePattern = styled.div<WaveProps>`
    position: fixed;
    top: 40%;
    width: 100vw;
    display: ${({show})=>show && show === 'true' ? "block" : "none"};

    @media (min-width: 768px) {
        position: relative;
        width: 100%;
        top: 0;
        
    }
`

export const VideoButton = styled.div`
    display: block;
    margin: 15px auto 0;
`